import { action, makeObservable, observable } from 'mobx';

export default class homeStore implements PageStore {
  constructor() {
    makeObservable(this);
  }

  @action
  onLoad = async () => {};

  @action
  onUnload = () => {};
}
